import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { VacanciesHero } from "../components/vacancies/VacanciesHero";
import { VacanciesWhy } from "../components/vacancies/VacanciesWhy";
import { VacanciesList, VACANCIES } from "../components/vacancies/VacanciesList";
import { VacanciesInternship } from "../components/vacancies/VacanciesInternship";
import { VacancyForm } from "../components/vacancies/VacancyForm";
import { Stats } from "../components/shared/Stats";
import { SITE_URL, breadcrumbJsonLd, buildMeta } from "../lib/site";
import { crumbTuples } from "../lib/breadcrumbs";

const title = "Вакансии и стажировка в маркетинговом агентстве HAY.agency";
const description =
  "Открытые вакансии HAY.agency: маркетолог, аналитик, PR-manager, а также стажировка. Онлайн-формат, реальные проекты и сильная команда.";

export const Route = createFileRoute("/vacancies")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/vacancies",
      image: `${SITE_URL}/og/default.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "Вакансии HAY.agency",
      locale: "ru_RU",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": `${SITE_URL}/vacancies#webpage`,
              url: `${SITE_URL}/vacancies`,
              name: title,
              description,
              inLanguage: "ru-RU",
              isPartOf: { "@id": `${SITE_URL}/#website` },
              breadcrumb: { "@id": `${SITE_URL}/vacancies#breadcrumbs` },
              mainEntity: VACANCIES.map((vacancy) => ({
                "@type": "JobPosting",
                title: vacancy.title,
                description: vacancy.lead,
                employmentType: "FULL_TIME",
                hiringOrganization: { "@id": `${SITE_URL}/#organization` },
                jobLocationType: "TELECOMMUTE",
                applicantLocationRequirements: {
                  "@type": "Country",
                  name: "Россия",
                },
              })),
            },
            breadcrumbJsonLd(crumbTuples("/vacancies"), {
              id: `${SITE_URL}/vacancies#breadcrumbs`,
              inGraph: true,
            }),
          ],
        }),
      },
    ],
  }),
  component: VacanciesPage,
});

function VacanciesPage() {
  return (
    <ServicePageLayout breadcrumb="Вакансии" jsonLd={false}>
      <VacanciesHero />
      <VacanciesWhy />
      <VacanciesList />
      <VacanciesInternship />
      <Stats />
      <VacancyForm />
    </ServicePageLayout>
  );
}
